$(function(){
//Overrides 
  //Code for youtube video hero
  /*if( $("[data-herovideo-type='youtube']").length ){
      var tag = document.createElement('script');

      tag.src = "https://www.youtube.com/iframe_api";
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
      
    
    
    $.each($("[data-herovideo-type='youtube']"), function(){
      var id = $(this).attr('id');
      var videoid = $(this).attr('data-video-id');
      var player;
      
      //var iframe = '<iframe id="'+id+'" data-video-id="'+videoid+'" frameborder="0" allowfullscreen="1" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" title="" width="'+videoOptions.width+'" height="'+videoOptions.height+'" src="https://www.youtube.com/embed/'+videoid+'?autohide='+videoOptions.autohide+'&amp;branding='+videoOptions.branding+'&amp;cc_load_policy='+videoOptions.cc_load_policy+'&amp;controls='+videoOptions.controls+'&amp;fs='+videoOptions.fs+'&amp;iv_load_policy='+videoOptions.iv_load_policy+'&amp;modestbranding='+videoOptions.modestbranding+'&amp;playsinline='+videoOptions.playsinline+'&amp;quality='+videoOptions.quality+'&amp;rel='+videoOptions.rel+'&amp;showinfo='+videoOptions.showinfo+'&amp;wmode='+videoOptions.wmode+'&amp;enablejsapi=1&amp;origin='+window.location.protocol + "//"+window.location.host+'&amp;widgetid=2" tabindex="-1"></iframe>';
      //$(this).replaceWith(iframe);
    });
  }*/
});
/*var videoOptions = {
      width: 1280,
      height: 720,
      playerVars: {
        autohide: 0,
        autoplay: 1,
        branding: 0,
        cc_load_policy: 0,
        fs: 0,
        iv_load_policy: 3,
        modestbranding: 1,
        playsinline: 1,
        quality: 'hd720',
        rel: 0,
        showinfo: 0,
        wmode: 'opaque',
        origin: window.location
      },
      events: {
        //onReady: onPlayerReady
      }
    };
var player;
function onYouTubeIframeAPIReady () {
  $.each($("[data-herovideo-type='youtube']"), function(){
    //console.log('r');
    var id = $(this).attr('id');
    var videoid = $(this).attr('data-video-id');
    player = new YT.Player(id, {
      height: videoOptions.height,
      width: videoOptions.width,
      videoId: videoid,
      playerVars: videoOptions.playerVars,
      events: {
        'onReady': onPlayerReady,
        //'onStateChange': onPlayerStateChange
      }
    });
	
    //var iframe = '<iframe id="'+id+'" data-video-id="'+videoid+'" frameborder="0" allowfullscreen="1" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" title="" width="'+videoOptions.width+'" height="'+videoOptions.height+'" src="https://www.youtube.com/embed/'+videoid+'?autohide='+videoOptions.autohide+'&amp;branding='+videoOptions.branding+'&amp;cc_load_policy='+videoOptions.cc_load_policy+'&amp;controls='+videoOptions.controls+'&amp;fs='+videoOptions.fs+'&amp;iv_load_policy='+videoOptions.iv_load_policy+'&amp;modestbranding='+videoOptions.modestbranding+'&amp;playsinline='+videoOptions.playsinline+'&amp;quality='+videoOptions.quality+'&amp;rel='+videoOptions.rel+'&amp;showinfo='+videoOptions.showinfo+'&amp;wmode='+videoOptions.wmode+'&amp;enablejsapi=1&amp;origin='+window.location.protocol + "//"+window.location.host+'&amp;widgetid=2" tabindex="-1"></iframe>';
    //$(this).replaceWith(iframe);
  });

}
function onPlayerReady(event) {
  event.target.playVideo();
}*/

